// tslint:disable max-classes-per-file
import { Application, Content, Device, Group, User } from './index'
import { Structured } from './structured.model';

export class ConfirmationData {
  public title?: string;
  public startMessage?: string;
  public details?: { message: string; list: string[] };
  public endMessage?: string;
  public checkBox?: any;

  constructor(title?: string, startMessage?: string, endMessage?: string) {
    this.title = title || 'Confirm?';
    this.startMessage = startMessage || '';
    this.endMessage = endMessage || 'Are you sure?';
    this.checkBox = {
      show: false,
      message: false,
      tick: false,
    };
  }
}

export class ContentDeleteConfirmation extends ConfirmationData {
  constructor(deleteObj: Content) {
    super('Delete content confirmation');
    if (deleteObj) {
      if (deleteObj.type == 'STRUCTURED') {
        this.checkBox = {
          show: true,
          message: 'Delete all?',
          tick: false,
        };
      }
      if (deleteObj.subscribedDevices && deleteObj.subscribedDevices.length) {
        this.details = {
          message: 'Notice: deleting this content means:',
          list: [
            `It will be deleted from ${deleteObj.subscribedDevices.length
            } subscribed devices`,
          ],
        };
      }
    }
  }
}

export class StructNodeDeleteConfirmation extends ConfirmationData {
  constructor(deleteObj: Structured) {
    super('');
    if (deleteObj.type == 'DIRECTORY') {

      this.checkBox = {
        show: true,
        message: 'Delete all of the nodes inside?',
        tick: false,
      };
    }
  }
}

export class DeviceDeleteConfirmation extends ConfirmationData {
  constructor(deleteObj?: Device) {
    super('Delete confirmation');
  }
}

export class UserDeleteConfirmation extends ConfirmationData {
  constructor(deleteObj?: User) {
    super('Delete confirmation');
    if (deleteObj.myDevices && deleteObj.myDevices.length) {
      this.details = {
        message: 'Deleting "' + deleteObj.name + '" will:',
        list: ['Remove user from ' + deleteObj.myDevices.length + ' devices'],
      };
      if (deleteObj.myContents && deleteObj.myContents.length) {
        this.details.list.push(
          'Change the owner of ' +
          deleteObj.myContents.length +
          ' contents to user admin',
        );
      }
    }
  }
}

export class GroupDeleteConfirmation extends ConfirmationData {
  constructor(deleteObj: Group) {
    super('Delete confirmation');
    this.endMessage = 'Do you want to delete the group?';
    if (deleteObj.children.length) {
      this.startMessage = '';
      this.details = {
        message: 'This group has other subgroups.',
        list: ['Sub-groups will be deleted'],
      };
      this.details.list.push();
      this.endMessage = 'Do you want to continue?';
    }
  }
}

export class AppDeleteConfirmation extends ConfirmationData {
  constructor(deleteObj: Application) {
    super('Delete app confirmation');
    if (deleteObj && deleteObj.subscribedDevices && deleteObj.subscribedDevices.length) {
      this.details = {
        message: 'Notice: deleting this app means:',
        list: [
          `It will be deleted from ${deleteObj.subscribedDevices.length} subscribed devices`,
          `C3s will loose this app data`,
        ],
      };
      this.details.list.push();
    }
  }
}

export class UnsubContentConfirmation extends ConfirmationData {
  constructor() {
    super(
      'Unsubscribe confirmation',
      'This content will be removed from the device.',
      'Continue?',
    );
  }
}
export class UnsubAppConfirmation extends ConfirmationData {
  constructor() {
    super(
      'Unsubscribe confirmation',
      'Removing this App from the C3 will remove all its data. You won’t be able to go back!',
      'Do you want to proceed?',
    );
  }
}
